<!-- TITULO A RECEBER

VALIDACOES:
- desabilita a alteracao da conta bancaria quando a remessa foi enviada (stremessa = 1 and stremessa = 2)
-->

<template>
<div class="nb-modal-scrollable" id="nb-modal-scrollable">
    <div id="mymodal"  class="container nb-modal-scrollable-container">
        <div v-if="!showFormPedido && !showFormNF" class="nb-modal-scrollable-body">
                <div>
                    <template v-if="localCrud != null">
                        <bar-manut
                            :single-entity="title" 
                            :crud="localCrud" 
                            :moreActions="moreActions"
                            @action="handleAction"
                            @closeform="closeForm" 
                            @save="handleSave">
                        </bar-manut>
                    </template>
                    <!-- <template v-else>
                        <bar-manut
                        :single-entity="title" 
                        :crud="localCrud || ''" 
                        :moreActions="moreActions"
                        @action="handleAction"
                        @closeform="closeForm" 
                        @save="handleSave">
                    </bar-manut>
                    </template> -->
                    <!-- <bar-manut v-else
                        :single-entity="title" 
                        :crud="localCrud || ''" 
                        :moreActions="moreActions"
                        @action="handleAction"
                        @closeform="closeForm" 
                        @save="handleSave">
                    </bar-manut> -->
                    <div class="row">
                        <div class="col-md-9">

<!-- CANCELAMENTO DE TITULO -->
                            <div class="border p-2 mb-3" v-if="showCancela || showCancelaRec">
                                <label-title title="Confirmar Cancelamento" v-if="showCancela || showCancelaRec"></label-title>
                                <div class="row align-items-center px-2 pb-1" v-if="showCancela">
                                    <div class="col">
                                        <p>Deseja realmente cancelar este lançamento ?</p>
                                    </div>
                                </div>
                                <div class="row align-items-center px-2 pb-1" v-if="showCancelaRec">
                                    <div class="col">
                                        <p>O lançamento que está sendo cancelado possui vínculo com outras parcelas.</p>
                                        <p>Selecione abaixo quais lançamentos deseja cancelar agora.</p>
                                    </div>
                                </div>
                                <div class="row align-items-center px-2 pb-5" v-if="showCancelaRec">
                                    <div class="col-12">
                                        <div class="w-100">
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio1" class="custom-control-input" value="1" v-model="tipoCancelamento">
                                                <label class="custom-control-label data-list" for="customRadio1">Cancelar somente este lançamento</label>
                                            </div>
                                        </div>
                                        <div class="w-100">
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio2" class="custom-control-input" value="2" v-model="tipoCancelamento">
                                                <label class="custom-control-label data-list" for="customRadio2">Cancelar este e os demais lançamentos em <b> aberto </b></label>
                                            </div>
                                        </div>
                                        <div class="w-100">
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio3" class="custom-control-input" value="3" v-model="tipoCancelamento">
                                                <label class="custom-control-label data-list" for="customRadio3">Cancelar <b>todos</b> os lançamentos</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row align-items-center" v-if="tipoCancelamento=='3'">
                                    <div class="col-12">
                                        <input-checkbox v-model="cancelaBaixados" :value-checked="true" :value-unchecked="false" label="Cancelar lançamentos baixados"></input-checkbox>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-12">
                                        <v-button label="Confirmar Cancelamento" title="" :danger="true" @click="handleCancelar"></v-button>
                                        <v-button label="Desistir" @click="handleCancelarExclusao"></v-button>
                                    </div>
                                </div>
                            </div>
<!-- FIM CANCELAMENTO DE TITULO -->
                            <div class="row mb-3" v-if="fin.codpedv || fin.codnf || fin.tipofin == 'R'" >
                                <div class="col-md-3" v-if="fin.codpedv" >
                                   <label class="lbl-list">Pedido</label><br>
                                   <a href="javascript:void(0);"
                                        @click="openFormPedido">
                                      Nr.:{{fin.pedv[0].npedido}}
                                   </a>
                                </div>
                                <div class="col-md-3" v-if="fin.codnf" >
                                   <label class="lbl-list">Nota Fiscal</label><br>
                                   <a href="javascript:void(0);"
                                      @click="openFormNF">
                                      Doc.:{{fin.nf[0].nf}}
                                   </a>
                                </div>
                                <div class="col-md-2" v-if="fin.tipofin == 'R'" >
                                   <label class="lbl-list">Nr. Remessa</label><br>
                                   <span class="data-list-sm" data-toggle="tooltip" data-placement="top">{{ fin.numbordero }}</span>
                                </div>
                                <div class="col-md-2" v-if="fin.tipofin == 'R'" >
                                   <label class="lbl-list">Data Remessa</label><br>
                                   <span class="data-list-sm" data-toggle="tooltip" data-placement="top">{{ dataStr(fin.dtremessa) }}</span>
                                </div>
                                <div class="col-md-2" v-if="fin.tipofin == 'R'" >
                                   <label class="lbl-list">Status Remessa</label><br>
                                   <span class="data-list-sm" data-toggle="tooltip" data-placement="top">{{ textSTREMESSA(fin.stremessacnab) }}</span>
                                </div>
                                <div class="col-md-2" v-if="fin.tipofin == 'R' && fin.stremessacnab == 1">
                                   <label class="lbl-list">Codfin(ID)</label><br>
                                   <span class="data-list-sm" data-toggle="tooltip" data-placement="top">{{ fin.codfin }}</span>
                                </div>
                            </div>


                            <div class="row">
                                <!-- <form-field v-model="fin.codfin" :metadata="metadata.fin.codfin" type="text" col="3" :disabled="true"></form-field> -->
                                <form-field ref="doc" v-model="fin.doc" type="text" col="3" :metadata="metadata.fin.doc" :disabled="isView || _tituloNF || _bloqueiaAlteracao" 
                                    name="doc" :v-errors="errors" v-validate="metadata.fin.doc.validator"></form-field>
                                <form-field v-model="fin.parcela" type="number" col="3" :metadata="metadata.fin.parcela" :disabled="isView || _bloqueiaAlteracao"
                                    name="parcela" :v-errors="errors" v-validate="metadata.fin.parcela.validator"></form-field>
                                <form-field v-model="fin.data" type="date" col="3" :metadata="metadata.fin.data" :disabled="isView || _tituloNF || _bloqueiaAlteracao"
                                    name="data" :v-errors="errors" v-validate="metadata.fin.data.validator"></form-field>
                            </div>
                            <!-- MENSAGENS DE VALIDACAO -->
                            <validation v-if="errmessages" title="Erros de Validação" :messages="errmessages"></validation>
                            <!-- FIM MENSAGENS DE VALIDACAO -->
                            <div class="row">
                                <!-- <form-field v-model="fin.codpart" type="select2" col="6" :label="clienteFornecedor" :metadata="metadata.fin.codpart" :disabled="isView || _tituloNF || _bloqueiaAlteracao" -->
                                <!--     parent="mymodal" name="codpart" :v-errors="errors" v-validate="metadata.fin.codpart.validator"></form-field> -->
                                <form-field v-model="fin.codpart" type="select2" col="6" :label="clienteFornecedor" :metadata="metadata.fin.codpart" :disabled="isView || _bloqueiaAlteracao"
                                    parent="mymodal" name="codpart" :v-errors="errors" v-validate="metadata.fin.codpart.validator" :add-button="true" @clickAdd="handleIncluir('part')"  ></form-field>
                                <form-field v-model="fin.descricao" type="text" col="6" :metadata="metadata.fin.descricao" :disabled="_bloqueiaAlteracao"
                                    name="descricao" :v-errors="errors" v-validate="metadata.fin.descricao.validator"></form-field>
                            </div>
                            <div class="row">
                                <form-field v-model="fin.dtv" type="date" col="3" :metadata="metadata.fin.dtv" :disabled="isView || _bloqueiaAlteracao"
                                    name="dtv" :v-errors="errors" v-validate="metadata.fin.dtv.validator"></form-field>
                                <form-field v-model="fin.vlr" type="value" col="3" :metadata="metadata.fin.vlr"  :disabled="isView || _tituloNF || _bloqueiaAlteracao"
                                    name="vlr" :v-errors="errors" v-validate="metadata.fin.vlr.validator"></form-field>
                                <form-field v-model="fin.pmulta" type="value" col="2" :metadata="metadata.fin.pmulta"  :disabled="isView || _bloqueiaAlteracao"
                                    name="pmulta" :v-errors="errors" v-validate="metadata.fin.pmulta.validator"></form-field>
                                <form-field v-model="fin.pmora" type="value" col="2" :metadata="metadata.fin.pmora"  :disabled="isView || _bloqueiaAlteracao"
                                    name="pmora" :v-errors="errors" v-validate="metadata.fin.pmora.validator"></form-field>
                                <form-field v-model="fin.formapag" type="select" col="3" :metadata="metadata.fin.formapag" :disabled="isView || _bloqueiaAlteracao"></form-field>
                            </div>
                            <div class="row">
                                <form-field v-model="fin.codcta" type="select2" col="6" :metadata="metadata.fin.codcta" :disabled="_habilitaConta"
                                    parent="mymodal" name="codcta" :v-errors="errors" v-validate="metadata.fin.codcta.validator"></form-field>
                                <form-field v-model="fin.codnatfin" type="select2" col="6" :metadata="metadataCodnatfin" :disabled="_bloqueiaAlteracao"
                                    parent="mymodal" name="codnatfin" :v-errors="errors" v-validate="metadata.fin.codnatfin.validator"></form-field>
                            </div>
                            <div class="row">
                                <form-field v-model="fin.obs" type="memo" col="6" :metadata="metadata.fin.obs" :disabled="isView"
                                    parent="mymodal" name="obs" :v-errors="errors" v-validate="metadata.fin.obs.validator"></form-field>
                                    <div class="col-6">
                                        <form-field v-if="fin.log && fin.log.length > 0" v-model="fin.log[0]" type="memo"  :metadata="metadata.fin.log" :disabled="true"></form-field>
                                    </div>
                            </div>    
                            <div class="my-3 d-flex justify-content-end">
                                <a href="#historico">
                                 <v-button label="Visualzar histórico de alterações do título" @click="handleShowallLogs" success ></v-button>
                                </a>
                            </div>
                            <div id="historico" class="my-3" :style="showAllLogs ? 'opacity: 100%; height: auto' : 'opacity: 0; height: 0px'">
                                <strong>Historico de Alterações do Título</strong>
                                <div class="border" style="background: #eaeaea">
                                    <ul class="py-4">
                                        <li class="my-1" v-for="(log, index) in fin.log" :key="index">{{log}}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row" v-if="!fin.codfin">
                                <form-field v-model="recorrencia" type="select" col="3" label="Parcelas/Recorrência"
                                    :select-options="recorrenciaOptions"></form-field>                                
                                <form-field v-if="recorrencia == 'P'" v-model="qtParcelas" type="number" col="3" label="Parcelas"
                                    :v-errors="errors" v-validate="{ required: true, max: 2 }"></form-field>
                                <form-field v-if="recorrencia != 'U' && recorrencia != 'P'" v-model="dataLimite" type="date" col="3" label="Data Limite"
                                    :v-errors="errors" v-validate="{ required: true, max: 2 }"></form-field>
                            </div>
                            <!-- <div class="row">
                                <form-field v-model="fin.dtgeracao" :metadata="metadata.fin.dtgeracao" type="date" col="3" :disabled="isView"></form-field>
                                <form-field v-model="fin.nrtitbanco" :metadata="metadata.fin.nrtitbanco" type="text" col="3" :disabled="true"></form-field>
                                <form-field v-model="fin.stremessacnab" :metadata="metadata.fin.stremessacnab" type="select" col="3" :disabled="true"></form-field>
                                <form-field v-model="fin.numbordero" :metadata="metadata.fin.numbordero" type="text" col="3" :disabled="true"></form-field>
                                <form-field v-model="fin.dtremessa" :metadata="metadata.fin.dtremessa" type="date" col="3" :disabled="true"></form-field>
                                <form-field v-model="fin.dtc" :metadata="metadata.fin.dtc" type="date" col="3" :disabled="true"></form-field>
                            </div> -->
                <!-- CHEQUE -->
                            <!-- <div class="row">
                                <input-switch type="success" label="Cheque?" v-model="fin.ischeque" value-checked="S" value-unchecked="N" :disabled="isView"></input-switch>
                                <form-field v-if="fin.ischeque=='S'" v-model="fin.bancocheque" type="text" col="3" :metadata="metadata.fin.bancocheque" :disabled="isView || _tituloNF || _bloqueiaAlteracao" 
                                    name="bancocheque" :v-errors="errors" v-validate="metadata.fin.bancocheque.validator"></form-field>
                                <form-field v-if="fin.ischeque=='S'" v-model="fin.ndoccheque" type="text" col="3" :metadata="metadata.fin.ndoccheque" :disabled="isView || _tituloNF || _bloqueiaAlteracao" 
                                    name="ndoccheque" :v-errors="errors" v-validate="metadata.fin.ndoccheque.validator"></form-field>
                            </div> -->

                        </div>
               <!-- BAIXA/PAGAMENTO -->
                        <div class="col-md-3" style="border-left: 1px solid silver">
                            <div class="row" v-if="fin.perdido == 'S'">
                                <div class="col text-center">
                                    <span class="badge badge-red">Perdido</span>
                                </div>
                            </div>
                            <div class="row" v-if="fin.cancelado == 'S'">
                                <div class="col text-center">
                                    <span class="badge badge-red">Cancelado</span>
                                </div>
                            </div>
                            <div class="row" v-if="fin.baixado == 'S'">
                                <div class="col text-center">
                                    <span v-if="fin.tipofin == 'R'" class="badge badge-green">Recebido <span v-if="fin.parcial == 'S'"> parcial</span></span>
                                    <span v-if="fin.tipofin == 'P'" class="badge badge-green">Pago <span v-if="fin.parcial == 'S'"> parcial</span></span>
                                </div>
                            </div>
                            <div class="row p-3" v-if="fin.cancelado == 'S'">
                                <input-switch type="danger" label="Reabrir Título Cancelado" v-model="reabrirCancelado" value-checked="S" value-unchecked="N"></input-switch>
                            </div>
                            <div class="row p-3" v-if="fin.baixado == 'S'">
                                <input-switch type="danger" label="Reabrir Título Baixado" v-model="reabrirBaixado" value-checked="S" value-unchecked="N"></input-switch>
                            </div>
                            <div class="row p-3" v-if="fin.tipofin == 'R' && fin.aberto == 'S'">
                                <input-switch type="success" label="Título Recebido" v-model="baixado" value-checked="S" value-unchecked="N" :disabled="isView"></input-switch>
                            </div>
                            <div class="row p-3" v-if="fin.tipofin == 'P' && fin.aberto == 'S'">
                                <input-switch type="success" label="Título Pago" v-model="baixado" value-checked="S" value-unchecked="N" :disabled="isView"></input-switch>
                            </div>
                            <div class="row mb-3" v-if="reabrirBaixado == 'S' || reabrirCancelado == 'S'">
                                <div class="col">
                                    <v-button label="Confirmar" title="" :danger="true" @click="handleConfirmaAlteracao"></v-button>
                                </div>
                            </div>

                            <div class="row" v-if="baixado==='S'">
                                <form-field v-model="fin.dtb" type="date" col="12" :metadata="metadata.fin.dtb"
                                    name="dtb" :v-errors="errors" v-validate="metadata.fin.dtb.validator" :disabled="isView"></form-field>
                                <form-field v-model="fin.vjuros" type="value" col="12" :metadata="metadata.fin.vjuros" 
                                    name="vjuros" :v-errors="errors" v-validate="metadata.fin.vjuros.validator" :disabled="isView"></form-field>
                                <form-field v-model="fin.vdescontos" type="value" col="12" :metadata="metadata.fin.vdescontos" 
                                    name="vdescontos" :v-errors="errors" v-validate="metadata.fin.vdescontos.validator" :disabled="isView"></form-field>
                                <form-field v-model="fin.vpago" type="value" col="12" :metadata="metadata.fin.vpago" 
                                    name="vpago" :v-errors="errors" v-validate="metadata.fin.vpago.validator" :disabled="isView"></form-field>
                                <alert v-if="baixaParcial" type="info" text="Um novo título será criado com o saldo"></alert>
                            </div>
                        </div>
                    </div>
                </div>

               
        </div>

          <transition name="fade">
            <fv-pedido-form v-if="showFormPedido" name="pedido" ref="pedido" :index="fin.codpedv" :crud="'view'" @closeform="closeFormPedido"></fv-pedido-form>
          </transition>

          <transition name="fade">
            <nfsaida-form v-if="showFormNF" name="notafiscal" ref="notafiscal" :params="params" :crud="'view'" @closeform="closeFormNF" @edit="closeFormNF"></nfsaida-form>
          </transition>


    </div>


    <!-- ALTERAÇÃO DE CONTAS RECORRENTES -->
    <div class="nb-modal-scrollable" v-if="showPerguntaRecorrente">
        <div class="container nb-modal-scrollable-container">
            <div class="nb-modal-header">
                <h4 class="def-title">Alteração de Conta Recorrente</h4>
            </div>
            <div class="nb-modal-scrollable-body">
                <div class="row">
                    <p>O lançamento que está sendo alterado possui vínculo com outras parcelas.</p>
                    <p>Selecione abaixo quais lançamentos deseja alterar agora.</p>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="w-100" v-if="true">
                            <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio1" class="custom-control-input" value="1" v-model="tipoAlteracao">
                                <label class="custom-control-label data-list" for="customRadio1">Alterar somente o lançamento atual</label>
                            </div>
                        </div>
                        <div class="w-100">
                            <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio2" class="custom-control-input" value="2" v-model="tipoAlteracao">
                                <label class="custom-control-label data-list" for="customRadio2">Alterar o lançamento atual e os demais lançamentos em <b> aberto </b></label>
                            </div>
                        </div>
                        <div class="w-100">
                            <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio3" class="custom-control-input" value="3" v-model="tipoAlteracao">
                                <label class="custom-control-label data-list" for="customRadio3">Alterar <b>todos</b> os lançamentos</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nb-modal-footer" style="height: 10%">
                <v-button label="Confirmar" title="" :danger="true" @click="handleConfirmaAlteracao"></v-button>
                <v-button label="Cancelar" title="" @click="handleCancelarAlteracao"></v-button>
            </div>
        </div>
    </div>

    <transition name="fade">
          <div class="nb-modal-scrollable" v-if="showPartForm">
            <div class="container nb-modal-scrollable-container nb-email-container">
                <div class="nb-modal-scrollable-body">
                  <customer-form  crud="ins" @closeform="closePartForm"></customer-form>
                </div>
            </div>
        </div>


    </transition>



</div>

</template>

<script>

import axios from 'axios'
import { apiORDS, apiORDSpost, urlODS } from '../shared/api-functions'
import FvPedidoForm from '../forms-fv/fv-pedido-form'
import nfsaidaForm from './nfsaida-form'
import customerForm from './customer-form'
import { SysVars } from '../main'
import { getText, formatDate, formatValue } from '../shared/utils'

export default {
    props: {
        index: '',
        tipo: '',
        crud: '',
    },

    data () {
        return {
            crudText: '',
            showFormPedido: false, //exibe a tela de manutencao
            showFormNF: false, //exibe a tela de manutencao
            params: { outrasSaidas: true, codnf: 0, codpedv: 0 },
            fin: {...this.$store.getters.getEntities.fin},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            baixado: 'N',
            reabrirBaixado: 'N',
            reabrirCancelado: 'N',
            baixaParcial: false,
            recorrenciaOptions: [{ id: 'U', text: "Única" }, { id: 'P', text: "Parcelado" }, { id: 'M', text: "Mensal" }, { id: 'T', text: "Trimestral" }, { id: 'A', text: "Anual" }],
            recorrencia: 'U',
            dataLimite: null,
            qtParcelas: null,
            showPerguntaRecorrente: false,
            tipoAlteracao: false,

            showPartForm: false,
            showCancelaRec: false,
            showCancela: false,
            titleExclusao: 'Cancelar Titulo',
            tipoCancelamento: null,
            cancelaBaixados: false,
            localCrud: null,
            showAllLogs: false
        }
    },

    components: {
        FvPedidoForm, nfsaidaForm, customerForm 
    },


    computed: {
        metadataCodnatfin: function () {
            let meta = {...this.metadata.fin.codnatfin }
            if (this.fin.tipofin == 'R' || this.fin.tipofin == 'E')
              meta.select2.entity = 'natfin/receitas'
            else
              meta.select2.entity = 'natfin/despesas'
            return meta
        },
        moreActions: function () {
            if (this.crud == SysVars.crudI)
              return null

            let actions = []
            if ((this.fin.aberto == 'S') && (this.fin.cancelado != 'S') && (this.fin.devolvido != 'S') && (this.fin.stremessacnab != 1)){
                actions.push({ action: 1, label: 'Cancelar Título' })
            }
            // if (this.fin.cancelado == 'S')
            //     actions.push({ action: 2, label: 'Desfazer Cancelamento' })
            return actions
        },

        title: function () {
            if (this.tipo == 'R')
              return 'Contas a Receber'
            else
              return 'Contas a Pagar'
        },

        clienteFornecedor: function () {
            if (this.tipo == 'R')
              return 'Cliente'
            else
              return 'Fornecedor'
        },

        editing: function () {
            return this.crud == SysVars.crudU
        },

        isView: function () {
            return (this.crud == SysVars.crudView || this.fin.baixado == 'S' || this.fin.cancelado == 'S' || this.fin.perdido == 'S')
        },

        _habilitaConta: function () {
            //HABILTA EDICAO DA CONTA BANCARIA SOMENTE QUANDO NAO ENVIADO POR REMESSA
            if (this.fin.stremessacnab != '1' && this.fin.stremessacnab != '2' && !this.isView) {
                return false
            } else {
                return true
            }
        },

        _bloqueiaAlteracao: function () {
            return this.fin.cancelado == 'S' || this.fin.devolvido == 'S' || this.fin.stremessacnab == 1 || this.fin.stremessacnab == 2
        },

        _tituloNF: function () {
            if (!this.fin.codnf && !this.fin.codpedv) {
                return false
            } else {
                return true
            }
        },

        vpago: function () {
            return this.fin.vpago
        },

        vjuros: function () {
            return this.fin.vjuros
        },

        vdescontos: function () {
            return this.fin.vdescontos
        },

        vabatimento: function () {
            return this.fin.vabatimento
        },

    },

    methods: {

        closePartForm (id) {
            if (id) this.fin.codpart = id
            this.showPartForm = false
        },

        handleIncluir (pTipo) {
            //exibe tela de cadastro
            if (this.isView) {
                return
            }

            if (pTipo === 'part') {
                this.showPartForm= true
            }

        },

        handleShowallLogs(){
            this.showAllLogs = !this.showAllLogs;

            const to = document.getElementById('historico').offsetTop;

            document.getElementById('nb-modal-scrollable')
                .scroll({
                    top:this.showAllLogs ? to : 100,
                    behavior: 'smooth'
                })

        },
        dataStr(data) {
            if (!data) 
              return ''
            else
              return formatDate(data)
        },
 

        textSTREMESSA (value) {
            return getText(value, this.metadata.fin.stremessacnab)
        },

        openFormNF(){
          this.params = { codnf: this.fin.codnf }
          this.showFormNF = true
        },

        closeFormNF(){
          this.showFormNF = false
        },

        openFormPedido(){
          this.showFormPedido = true
        },

        closeFormPedido(){
            this.showFormPedido = false
        },
      
        handleAction (act) {
            if (act == 1)
                this.handleShowCancela()
        },

        handleConfirmaAlteracao () {
            this.showPerguntaRecorrente = false
            this.handleSave()
        },

        handleCancelarAlteracao () {
            this.showPerguntaRecorrente = false
        },

        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid && this.reabrirCancelado !== 'S') {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },
        handleLog(){
            if(this.fin.log){
                this.fin.log = this.fin.log.split('\r');
            }
           if ((!this.fin.log) || (this.fin.log.length == 0)) {
              this.fin.log = [''] 
           } 
        },
        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            if (this.crud == SysVars.crudI) {
                this.fin.tipofin = this.tipo
                if (this.fin.tipofin == 'R'){
                    this.fin.codnatfin = 3
                }else{
                    this.fin.codnatfin = 52
                }  

                this.fin.aberto = 'S'
                this.fin.baixado = 'N'
                this.fin.parcela = '1'
                this.fin.data = this.$getDate()
                this.fin.dtv = this.$getDate()
                this.localCrud = this.crud
                return
            }

            await this.$store.dispatch('loadFin', { id: this.index } )
            if (this.$store.getters.getFin) {
                this.fin = {...this.$store.getters.getFin}
                this.baixado = this.fin.baixado

                
            }
            if(this.fin.codcta == null){
                this.fin.codcta = ''
            }
            this.baixado = this.fin.baixado
            this.handleLog();
            if (this.fin.baixado == 'S' || this.fin.aberto == 'S') 
              this.localCrud = SysVars.crudUpdate
            else 
              this.localCrud = this.crud

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'fin/movimento/' + this.fin.codfin

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            let vbaixado = parseFloat(this.fin.vpago) - parseFloat(this.fin.vdescontos) + parseFloat(this.fin.vjuros)
            if (this.fin.vlr < vbaixado || vbaixado <= 0) {
                this.$erpToastError('O valor pago é inválido')
                return
            }

            var modulo = 'fin/movimento/'
            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                modulo = modulo + this.fin.codfin
                update = true
            }

            var sendData = { fin: {...this.fin} }
            sendData.tipoAlteracao = this.tipoAlteracao 
            sendData.fin.baixado = this.baixado
            sendData.fin.qtParcelas = this.qtParcelas
            sendData.fin.dataLimite = this.dataLimite
            sendData.fin.recorrencia = this.recorrencia

            if (this.reabrirBaixado == 'S') {
              sendData.fin.baixado = 'N'
              sendData.fin.aberto = 'S'
              sendData.reabrir = true
            }
            if (this.reabrirCancelado == 'S') {
              sendData.fin.cancelado = 'N'
              sendData.fin.aberto = 'S'
              sendData.reabrir = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.reabrirCancelado = 'N'
                this.reabrirBaixado = 'N'
                if (this.reabrirBaixado == 'S' || this.reabrirCancelado == 'S')
                    this.loadData()
                else
                    this.closeForm()
            }
        },

        handleShowCancela () {
            this.tipoCancelamento = null;
            this.cancelaBaixados = null;
            if (this.fin.recorrente)
                this.showCancelaRec = true
            else
                this.showCancela = true
        },

        async handleCancelar () {
            this.showCancelaRec = false
            this.showCancela = false

            var modulo = 'fin/movimento/' + this.fin.codfin
            let postData = { cancela: true, codfin: this.fin.codfin, tipo: this.tipoCancelamento, cancelaBaixados: this.cancelaBaixados }
            const data = await apiORDSpost(this.$store, modulo, postData, 'put')
            this.$erpToastDeleted()
            this.closeForm()
        },

        handleCancelarExclusao () {
            this.showCancelaRec = false
            this.showCancela = false
            this.codfin = null;
            this.tipoCancelamento = null;
            this.cancelaBaixados = null;
       },
       handleEventEsc(event){
        if(event.keyCode == 27){
            this.closeForm();
            
        }
       }

    },
    beforeDestroy(){
        window.removeEventListener('keyup', this.handleEventEsc);
    },
    watch: {
        baixado: function(value) {
            if (value === 'S') {
                //ATRIBUI A DATA ATUAL À DATA DA BAIXA
                if (!this.fin.dtb) {
                    this.fin.dtb = this.$getDate()
                }
            }
        },

        vjuros: function(value) {
            this.fin.vpago = parseFloat(this.fin.vlr) - parseFloat(this.fin.vdescontos) + parseFloat(this.fin.vjuros)
        },

        vdescontos: function(value) {
            this.fin.vpago = parseFloat(this.fin.vlr) - parseFloat(this.fin.vdescontos) + parseFloat(this.fin.vjuros)
        },

        vpago: function(value) {
            if (this.fin.vlr > (parseFloat(this.fin.vpago) + parseFloat(this.fin.vdescontos) - parseFloat(this.fin.vjuros))) {
                this.baixaParcial = true
            } else {
                this.baixaParcial = false
            }
        }


    },

    beforeCreate () {

    },

    async created () {
        this.$nextTick(function () {
          this.$refs.doc.$el.querySelector('input').focus()
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        await this.loadData()  
    },

    mounted(){
        this.showFormNF = false
        this.showFormPedido = false
        window.addEventListener('keyup', this.handleEventEsc)
      }


}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/forms/financeiro-form.vue